import styled from "styled-components"
import { Button } from "client/components"

export const SearchPanelWrapper = styled.div`
    display: flex;
    width: 100%;
    padding: 6px 10px;
    background: ${(props) => props.theme.driveToolbarBackgroundColor};
    border-bottom: solid 2px ${(props) => props.theme.driveToolbarBorderColor};
`
export const ActionButtonWrapper = styled.div`
    display: flex;
    padding-left: 10px;

    & > ${Button} {
        margin-bottom: 0;
    }
`
